import {
  Directive,
  HostListener,
  HostBinding,
  Output,
  EventEmitter,
  ElementRef,
  Input,
} from '@angular/core';

@Directive({
  selector: '[xemexFilesDrop]',
  standalone: true,
})
export class FilesDropDirective {
  private _enabled: boolean = true;
  private _dragInProgress: boolean = false;

  @Input() acceptedTypes: string[] = [];

  @Input() set xemexFilesDrop(value: any) {
    this._enabled = value === '' ? true : !!value;
  }

  @HostBinding('class.bg-primary-hover') get dragInProgress() {
    return this._dragInProgress;
  }

  @Output() dropped: EventEmitter<any>;

  constructor(private element: ElementRef) {
    this.dropped = new EventEmitter();
  }

  @HostListener('dragenter', ['$event'])
  @HostListener('dragover', ['$event'])
  protected handleDragOver(event: any): void {
    if (!this._enabled) {
      return;
    }
    event.dataTransfer.dropEffect = 'move';
    this.stopAndPreventDefault(event);
    this._dragInProgress = true;
  }

  @HostListener('dragleave', ['$event'])
  @HostListener('dragend', ['$event'])
  protected handleDragEnd(event: any): void {
    if (!this._enabled) {
      return;
    }
    this.stopAndPreventDefault(event);
    event.dataTransfer.effectAllowed = 'copy';
    this._dragInProgress = false;
  }

  @HostListener('drop', ['$event'])
  protected handleDrop(event: any): void {
    this.stopAndPreventDefault(event);
    this._dragInProgress = false;
    const filesArray = Array.from(event.dataTransfer.files);
    if (this.acceptedTypes.length) {
      const result = filesArray.filter((file: any) => {
        const fileNameSplit = file.name.split('.');
        return this.acceptedTypes.includes(`.${fileNameSplit[fileNameSplit.length - 1]}`);
      });
      this.dropped.emit(result);
      return;
    }
    this.dropped.emit(filesArray);
  }

  stopAndPreventDefault(e: UIEvent): void {
    e.stopPropagation();
    e.preventDefault();
  }
}
